import {Inject, Injectable} from '@angular/core';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PublishedNutrition} from '@emm/core/models/published-menu.model';
import {switchMap} from 'rxjs/operators';

@Injectable()
export class NutritionPublishingService {
    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    getNutritionPublishToken(): Observable<{ token: string, expiry: number }> {
        return this.http.post<{ token: string, expiry: number }>(`${this.apiUrl}/nutrition/publish/token`, {});
    }

    publishChainwideNutrition(): Observable<PublishedNutrition> {
        return this.getNutritionPublishToken().pipe(
            switchMap((token: { token: string, expiry: number }) => {
                const headers = new HttpHeaders({ 'Publish-Token': token.token });
                return this.http.post<PublishedNutrition>(`${this.apiUrl}/nutrition/publish/chainwide`, {},
                    { headers }).pipe();
            })
        );
    }

    publishNutritionByStore(locationTag: string): Observable<PublishedNutrition> {
        return this.getNutritionPublishToken().pipe(
            switchMap((token: { token: string, expiry: number }) => {
                const headers = new HttpHeaders({ 'Publish-Token': token.token });
                return this.http.post<PublishedNutrition>(`${this.apiUrl}/nutrition/publish/location/${locationTag}`, {},
                    { headers }).pipe();
            })
        );
    }
}
